import { Component, NgZone, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { AppdataService } from 'src/app/services/app-data/appdata.service';
import { CommunicationInterfaceService } from 'src/app/services/communicationInterface/communication-interface.service';
import { LivechatStartService } from 'src/app/services/livechat-start/livechat-start.service';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent implements OnInit {
  appConfig: any;
  thankyouImg: string;
  thankyouLabels: {
    thankyouHeader: string;
    thankyouBody: string;
    thankyouButtonText: string;
  };
  appLabels: any;

  constructor(
    private route: Router,
    public zone: NgZone,
    private startService: LivechatStartService,
    private appDataService: AppdataService,
    private commInterface: CommunicationInterfaceService
  ) {
    this.commInterface.logToServer('info', 'ThankYouComponent.constructor', 'ThankYouComponent initiated');
  }

  ngOnInit(): void {
    this.appConfig = this.appDataService.getConfig();
    this.thankyouImg = this.appConfig?.thankyouImg;
    this.appLabels = this.appDataService.getLabels();
    this.thankyouLabels = this.appLabels?.thankyouComponent;
  }

  /**
   * Method to start over the app
   */
  startApp() {
    try {
      const navigationExtras: NavigationExtras = {
        queryParamsHandling: 'preserve',
        preserveFragment: true,
        queryParams: { ...this.startService.queryParameters },
        state: { reload: true }
      };
      this.zone.run(() => {
        this.route.navigate(['/'], navigationExtras);
      });
      this.commInterface.logToServer('info', 'ThankYouComponent.startApp', 'App started over');
    } catch (error) {
      console.error('%c Error Occured in startApp', 'color: red', error);
      this.commInterface.sendUIErrors('ThankYouComponent', 'startApp', JSON.stringify(error));
      this.commInterface.logToServer('error', 'Error occured in ThankYouComponent.startApp', JSON.stringify(error));
    }
  }
}
